export const SERVER = {
  url: process.env.REACT_APP_SERVER_URL || 'https://api.landed-cost.app',
  apiPath: 'api/v1'
}

// Marketing site (landed-cost-website): legal documents and the sales contact.
// Legal slugs mirror the site's LEGAL_DOCS (src/i18n/index.js there).
export const SITE = {
  url: process.env.REACT_APP_SITE_URL || 'https://portal.landed-cost.app',
  contactEmail: 'hello@landed-cost.app',
  legal: {
    terms: { 'es-MX': '/es/terminos-y-condiciones/', 'en-US': '/en/terms/' },
    privacy: { 'es-MX': '/es/aviso-de-privacidad/', 'en-US': '/en/privacy/' }
  },
  // The site's GUIDES.createShipment (src/i18n/index.js there).
  help: { 'es-MX': '/es/guias/como-crear-un-embarque/', 'en-US': '/en/guides/how-to-create-a-shipment/' }
}

export const legalUrl = (doc, locale) => `${SITE.url}${SITE.legal[doc][locale] || SITE.legal[doc]['en-US']}`
export const helpUrl = (locale) => `${SITE.url}${SITE.help[locale] || SITE.help['en-US']}`

// Routes reachable without a session (the 401 interceptor leaves them alone).
export const PUBLIC_PATHS = ['/login', '/signup', '/verify-email', '/forgot-password']

// Report layers of a landed cost, in the order the API returns them. Labels
// come from i18n (`layers.<key>`). Categorical colors in fixed order (validated
// reference palette); `other` is the neutral fold slot, never a generated hue.
export const LAYERS = [
  { key: 'merchandise', color: '#2a78d6' },
  { key: 'origin_logistics', color: '#eb6834' },
  { key: 'international_freight', color: '#1baf7a' },
  { key: 'insurance', color: '#eda100' },
  { key: 'destination_logistics', color: '#e87ba4' },
  { key: 'customs_broker', color: '#008300' },
  { key: 'duties_taxes', color: '#4a3aa7' },
  { key: 'final_delivery', color: '#e34948' },
  { key: 'other', color: '#8a8984' }
]

// Codes only; labels via i18n (`docTypes.*`, `transport.*`, `methods.*`, `bases.*`).
export const DOC_TYPES = ['commercial_invoice', 'packing_list', 'freight_invoice', 'forwarder_quote', 'customs_broker_account', 'pedimento', 'insurance', 'other']
export const TRANSPORT_MODES = ['sea_fcl', 'sea_lcl', 'air', 'land']
export const INCOTERMS = ['EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CPT', 'CIF', 'CIP', 'DAP', 'DPU', 'DDP']
export const ALLOCATION_BASES = ['value', 'weight', 'volume', 'quantity', 'duty']
